<template>
	<div class="repeater-wrap">
    <span class="label">{{ title }}</span>
    <div class="input-wrap input-wrap--address">
  		<button 
        class="input input--address address__button"
  			@click="openPanel">
        <address v-html="setFullAddress"></address>
  		</button>
      <Icon icon="house"></Icon>
    </div>
	</div>
</template>

<script>

/**
 * Modal JSFiddle
 * https://jsfiddle.net/yyx990803/mwLbw11k/?utm_source=website&utm_medium=embed&utm_campaign=mwLbw11k
 *
 * Repeater JSFiddle
 * https://jsfiddle.net/cr8vfgrz/10/
 */

import Icon  from './Icon.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Icon
  },  

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    openPanel() {

      this.$parent.$data.subpanel.field = this.field;
      // Proto is not required for the Address form, but we're passing it a string to maintain convention
      this.$parent.$data.subpanel.proto = "addressForm",  
      this.$parent.$data.subpanel.title = this.title,
      this.$parent.$data.subpanel.view  = 'addressForm';      

      this.$parent.$data.subpanel.data  = this.$store.getters.getFieldData(this.$parent.$data.subpanel);
      this.$parent.$data.subpanel.save  = JSON.parse( JSON.stringify( this.$parent.$data.subpanel.data ));

      this.$parent.$data.subpanel.state = 'active';

    },

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    setFullAddress() {

      return this.$store.getters.getAddress({field: this.field});

    },

  },

  props : [
  	'title',
  	'field',
  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .repeater-wrap {

    // border: 1px solid red;
    position: relative;
    margin: 0 0 .75rem;

    .icon {

      position: absolute;
      right: -1.5rem;
      top: 1em;

      width: 1rem;
      height: 1rem;

    }

    .icon__svg {

      fill: #444;
      stroke: #444;
    }

  }

  .input-wrap--address {

    width: calc(100% - 30px);

    address {

      font-style: normal;

    }

  }


</style>



// WEBPACK FOOTER //
// Address.vue?3712291e